import React from 'react';
interface DefaultVideoThumbnailProps extends React.SVGProps<SVGSVGElement> {}

export function DefaultVideoThumbnail(props: Readonly<DefaultVideoThumbnailProps>): JSX.Element {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 298 167.625"
			preserveAspectRatio="xMidYMid slice"
			fill="none"
			{...props}
		>
			<g clipPath="url(#a)">
				<path fill="#E6EAF8" d="M0 0h298v167.625H0z" />
				<g clipPath="url(#b)">
					<path
						fill="#F0AE00"
						fillRule="evenodd"
						d="M169.122 53.75a7.35 7.35 0 0 1 4.012 1.182 7.081 7.081 0 0 1 2.662 3.156 6.88 6.88 0 0 1 .414 4.066 6.986 6.986 0 0 1-1.973 3.604 7.277 7.277 0 0 1-3.695 1.928 7.39 7.39 0 0 1-4.171-.4 7.18 7.18 0 0 1-3.24-2.59 6.914 6.914 0 0 1-1.217-3.91 6.955 6.955 0 0 1 2.113-4.97 7.32 7.32 0 0 1 5.095-2.066Z"
						clipRule="evenodd"
					/>
					<path
						fill="#4C4C4E"
						d="M141.215 92.988c3.069-2.82 8.362-7.533 11.707-10.786 1.054-1.109 1.756-2.136 1.756-3.261 0-2.136-2.458-4.892-4.741-4.892-1.497 0-2.81.856-4.182 2.307l-14.818 14.757c.092-11.414.268-23.203.268-34.584 0-3.172-1.672-4.623-4.833-4.623-2.543 0-4.917 1.37-4.917 4.362.091 1.802.091 4.892.091 6.424 0 13.094.084 24.736.084 37.568l-.175 9.417c-.084 3.261 1.404 5.046 4.741 5.046 3.512 0 4.658-1.875 4.658-4.891l.083-8.39c.795-.766 2.902-2.739 3.78-3.505l11.933 14.137c1.322 1.63 2.551 2.649 4.131 2.649 2.718 0 5.018-2.56 5.018-4.533a4.093 4.093 0 0 0-1.23-2.739l-13.354-14.463Z"
					/>
					<path
						fill="#F0AE00"
						d="M128.774 100.349a2.157 2.157 0 0 1-1.192-.352 2.064 2.064 0 0 1-.783-.944 2.016 2.016 0 0 1-.103-1.21c.092-.405.306-.773.615-1.057l40.181-37.299c.41-.377.957-.58 1.521-.564.564.016 1.098.25 1.485.65s.595.933.579 1.483a2.054 2.054 0 0 1-.667 1.448l-40.139 37.29c-.405.37-.943.569-1.497.555Z"
					/>
				</g>
				<path
					stroke="#F7F8FD"
					strokeLinecap="round"
					strokeWidth={7.72}
					d="M3.86-3.86h93.132"
					transform="matrix(1 .00327 -.00326 1 -50 85.734)"
				/>
				<circle
					cx={58.815}
					cy={81.835}
					r={13.351}
					fill="#F7F8FD"
					stroke="#F7F8FD"
					strokeWidth={0.318}
					transform="rotate(42.9 58.815 81.835)"
				/>
				<path
					stroke="#F7F8FD"
					strokeLinecap="round"
					strokeWidth={4.539}
					d="M2.27-2.27h54.836"
					transform="rotate(90.052 126.384 90.286) skewX(.127)"
				/>
				<circle
					cx={219.162}
					cy={28.974}
					r={7.85}
					fill="#F7F8FD"
					stroke="#F7F8FD"
					strokeWidth={0.187}
					transform="rotate(132.702 219.162 28.974)"
				/>
				<path
					stroke="#F7F8FD"
					strokeLinecap="round"
					strokeWidth={5.046}
					d="M2.523-2.523h61.021"
					transform="rotate(-122.997 181.932 19.847) skewX(.004)"
				/>
				<circle
					cx={223.175}
					cy={124.653}
					r={8.727}
					fill="#F7F8FD"
					stroke="#F7F8FD"
					strokeWidth={0.208}
					transform="rotate(-80.287 223.175 124.653)"
				/>
			</g>
			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M0 0h298v167.625H0z" />
				</clipPath>
				<clipPath id="b">
					<path fill="#fff" d="M121.457 51.906h54.84v62.817h-54.84z" />
				</clipPath>
			</defs>
		</svg>
	);
}
